// /communications — lista geral de comunicações enviadas e recebidas.

import { useState } from 'react';

import { CommunicationsList } from '../../components/communications/CommunicationsList';
import { Field, Select } from '../../components/clients/form-primitives';
import { PageHelp } from '../../components/common/PageHelp';

type Channel = '' | 'email' | 'whatsapp' | 'sms';
type Direction = '' | 'outbound' | 'inbound';

export function CommunicationsPage(): JSX.Element {
  const [channel, setChannel] = useState<Channel>('');
  const [direction, setDirection] = useState<Direction>('');

  return (
    <div className="space-y-5">
      <header className="flex items-start gap-2">
        <div>
          <h1 className="m-0 text-[26px] font-bold tracking-[-0.025em] text-ink">Comunicações</h1>
          <p className="mt-1 text-[13px] text-muted">
            Histórico de mensagens enviadas e recebidas (régua de cobrança, alertas, inbound).
          </p>
        </div>
        <PageHelp id="communications" />
      </header>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <Field label="Canal">
          {({ inputId }) => (
            <Select
              id={inputId}
              value={channel}
              onChange={(e) => setChannel(e.target.value as Channel)}
            >
              <option value="">Todos</option>
              <option value="whatsapp">WhatsApp</option>
              <option value="email">E-mail</option>
              <option value="sms">SMS</option>
            </Select>
          )}
        </Field>
        <Field label="Direção">
          {({ inputId }) => (
            <Select
              id={inputId}
              value={direction}
              onChange={(e) => setDirection(e.target.value as Direction)}
            >
              <option value="">Todas</option>
              <option value="outbound">Enviadas</option>
              <option value="inbound">Recebidas</option>
            </Select>
          )}
        </Field>
      </div>

      <CommunicationsList
        filters={{
          ...(channel ? { channel } : {}),
          ...(direction ? { direction } : {}),
          pageSize: 100,
        }}
      />
    </div>
  );
}
